class Familia {
    constructor(
        {
            id = null,    
            cpf_requerente = null,
            nome_completo = null,        
            ind_beneficio_unico = null, 
            ind_beneficio_pobre = null,  
            ind_beneficio_ext_pobre = null, 
            ind_beneficio_smed = null,        
            usuario_inclusao = null, 
            data_registro_inclusao = null, 
            usuario_alteracao = null, 
            data_registro_alteracao = null,
            ind_ativo = null,
            numero_conta = null,
            agencia = null,
            dv_agencia = null,
            dv_conta = null,
            codigo_banco = null,
            nome_banco = null,
            beneficio_familia = []  
        } = {}
    ) {
        this.id = id; 
        this.cpf_requerente = cpf_requerente,  
        this.nome_completo = nome_completo,  
        this.ind_beneficio_unico = ind_beneficio_unico,       
        this.ind_beneficio_pobre = ind_beneficio_pobre,       
        this.ind_beneficio_ext_pobre = ind_beneficio_ext_pobre,       
        this.ind_beneficio_smed = ind_beneficio_smed,       
        this.usuario_inclusao = usuario_inclusao, 
        this.data_registro_inclusao = data_registro_inclusao, 
        this.usuario_alteracao = usuario_alteracao, 
        this.data_registro_alteracao = data_registro_alteracao,
        this.ind_ativo = ind_ativo,
        this.numero_conta = numero_conta,
        this.agencia = agencia,
        this.dv_agencia = dv_agencia,
        this.dv_conta = dv_conta,
        this.codigo_banco = codigo_banco,
        this.nome_banco = nome_banco,
        this.beneficio_familia = beneficio_familia
    }
}

export default Familia;